import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import { Home, NotFound, About, PrivacyPolicy, Disclaimer } from './pages';
import Foxandshadow from './pages/foxandshadow/Foxandshadow';
import FnSPressKit from './pages/foxandshadow/FnSPressKit';
import Parselings from './pages/parselings/Parselings';
import Article from './pages/home/components/Article';
import './App.css';

const App = () => {
  return (
      <div className="App">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/article/:id" element={<Article />} />
          <Route exact path="/aboutus" element={<About />} />
          <Route exact path="/legal/privacypolicy" element={<PrivacyPolicy />} />
          <Route exact path="/legal/disclaimer" element={<Disclaimer />} />
          <Route path="/foxandshadow" element={<Foxandshadow />} />
          <Route exact path="/foxandshadow/presskit" element={<FnSPressKit/>}/>
          <Route path="/parselings" element={<Parselings />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
  );
};

export default App;